import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { Checkbox, CheckboxInput, CheckboxInputLabel } from './checkboxes.styled';
import { FormContext } from '../../../shared/contexts/form-context';
import { Input, InputWrapper } from '../../common-field-styles';
import { ControlType } from '../../../../shared/form-lib';
import { ControlPropType } from '../../ctrl_proptype';

const OtherCheckbox = ({ ctrl, saveUpdatedCtrl, handleOptionChange }) => {
  const { inCustomise, inBuilder } = useContext(FormContext);
  const [otherText, setOtherText] = useState(ctrl.value?.[ControlType.OptOther.STRING] || '');

  const handleOtherOptionChange = () => {
    handleOptionChange(ControlType.OptOther.STRING, otherText);
    saveUpdatedCtrl(ControlType.OptOther.STRING, !ctrl[ControlType.OptOther.STRING]);
  };

  const handleOtherInputChange = (e) => {
    const newValue = e.target.value;
    setOtherText(newValue);
    handleOptionChange(ControlType.OptOther.STRING, newValue);
  };

  return (
    <>
      <Checkbox>
        <CheckboxInput
          type="checkbox"
          required={ctrl.props.required}
          onChange={handleOtherOptionChange}
          id={`fpl-${ctrl.internal_id}-other`}
          name={`fpl-${ctrl.internal_id}-other`}
          checked={ctrl[ControlType.OptOther.STRING] || false}
          disabled={ctrl.props.readonly || inCustomise || inBuilder}
          title={ctrl.props.readonly ? 'This field cannot be edited' : ''}
        />
        <CheckboxInputLabel
          notInBuilder={!inBuilder}
          htmlFor={`fpl-${ctrl.internal_id}-other`}
          title={ctrl.props.readonly ? 'This field cannot be edited' : ''}>
          {ctrl.props.other.label}
        </CheckboxInputLabel>
      </Checkbox>
      {ctrl[ControlType.OptOther.STRING] && (
        <InputWrapper>
          <Input
            type="text"
            value={otherText}
            notInBuilder={!inBuilder}
            required={ctrl.props.required}
            disabled={ctrl.props.readonly}
            onChange={handleOtherInputChange}
            aria-describedby="descriptive text"
            placeholder={ctrl.props.other.label}
            name={`fpl-${ctrl.internal_id}-other-input`}
          />
        </InputWrapper>
      )}
    </>
  );
};

OtherCheckbox.defaultProps = {};

OtherCheckbox.propTypes = {
  handleOptionChange: PropTypes.func.isRequired,
  saveUpdatedCtrl: PropTypes.func.isRequired,
  ctrl: PropTypes.shape(ControlPropType).isRequired,
};

export default OtherCheckbox;
